import {
  apiCheckWhatsApp,
  apiAddWhatsApp,
  apiGetFullWhatsAppList,
} from '../service/api.whatsApp.service'

/**
 * Clean phone input string:
 * - Strips non-digits
 * - Strips 62 or 0 prefix
 * - Ensures starting with 8
 * - Limits to max 13 digits
 */
export function cleanPhoneInput(val) {
  let cleaned = String(val || '').replace(/\D/g, '')
  if (cleaned.startsWith('62')) cleaned = cleaned.slice(2)
  while (cleaned.startsWith('0')) cleaned = cleaned.slice(1)
  if (cleaned && !cleaned.startsWith('8')) {
    cleaned = ''
  }
  if (cleaned.length > 13) cleaned = cleaned.slice(0, 13)
  return cleaned
}

/**
 * Keypress handler to block non-digits and block any first digit other than '8'
 */
export function handlePhoneKeypress(event) {
  if (!/\d/.test(event.key)) {
    event.preventDefault()
    return
  }
  const input = event.target
  const isStart = !input.value || input.selectionStart === 0
  if (isStart && event.key !== '8') {
    event.preventDefault()
  }
}

/**
 * Validates cleaned phone input starting with 8 and 8-13 digits
 */
export function validatePhoneInput(phone) {
  const cleaned = cleanPhoneInput(phone)
  if (!cleaned.startsWith('8')) {
    return { isValid: false, message: 'Nomor HP harus dimulai dengan angka 8' }
  }
  if (cleaned.length < 8) {
    return { isValid: false, message: 'Nomor HP minimal 8 digit' }
  }
  if (cleaned.length > 13) {
    return { isValid: false, message: 'Nomor HP maksimal 13 digit' }
  }
  return { isValid: true, cleaned, fullPhone: `0${cleaned}` }
}

/**
 * Workflow to check, add, and fetch newly created WhatsApp number record
 */
export async function registerNewWhatsAppNumber({ cleanedPhone, partnerId }) {
  const fullPhone = `0${cleanedPhone}`

  // 1. Check number validation
  const checkRes = await apiCheckWhatsApp(fullPhone)
  if (checkRes.data?.code === 1001) {
    throw new Error('Nomor sudah terdaftar')
  }
  if (checkRes.data?.code === 1002) {
    throw new Error('Nomor tidak terhubung dengan WhatsApp')
  }

  // 2. Add number via API
  if (partnerId) {
    await apiAddWhatsApp(fullPhone, partnerId)
  }

  // 3. Fetch full WhatsApp list to get the created record with id
  const listRes = await apiGetFullWhatsAppList()
  const items = listRes.data?.data || []
  const createdNumber = items.find(
    i => i.phone_number === fullPhone
      || i.phone_number === `+62${cleanedPhone}`
      || i.phone_number === `62${cleanedPhone}`
      || String(i.phone_number).replace(/\D/g, '').endsWith(cleanedPhone),
  )

  return {
    fullPhone,
    createdNumber: createdNumber || { phone_number: fullPhone },
  }
}

/**
 * Format raw phone number with +62 prefix
 */
export function formatRawPhone(phone) {
  if (!phone) return ''
  const raw = String(phone).trim()
  if (raw.startsWith('0')) {
    return `+62${raw.slice(1)}`
  }
  if (raw.startsWith('62')) {
    return `+${raw}`
  }
  if (!raw.startsWith('+62')) {
    return `+62${raw}`
  }
  return raw
}

/**
 * Format phone number for readable display (+62 8xx xxxx xxxx)
 */
export function formatDisplayPhone(phone) {
  if (!phone) return ''
  let raw = String(phone).trim()
  if (raw.startsWith('0')) {
    raw = `+62${raw.slice(1)}`
  } else if (raw.startsWith('62')) {
    raw = `+${raw}`
  } else if (!raw.startsWith('+62')) {
    raw = `+62${raw}`
  }

  const digits = raw.replace(/\D/g, '')
  if (digits.length >= 10) {
    const p1 = digits.slice(0, 5)
    const p2 = digits.slice(5, 9)
    const p3 = digits.slice(9)
    return `+${p1.slice(0, 2)}${p1.slice(2)} ${p2} ${p3}`
  }
  return raw
}
